import * as React from 'react';
import {useEffect} from 'react';
import {Paper, Button, Stack, Typography, Box} from '@mui/material';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import Divider from '@mui/material/Divider';
import UploadIcon from '@mui/icons-material/Upload';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import {useItemDetail} from './hooks/useItemDetail';
import DynamicForm from './DynamicForm';
import {useServiceFavorite} from '../service/hook/useServiceFavorite';
import {withServiceListContext} from '../service/state/serviceContext';
import {useParams} from 'react-router-dom';

const ItemDetailInformation = ({item, loading}) => {
  const {mode} = useDarkMode();
  const {addToFavorite, removeFromFavorite} = useServiceFavorite();
  const [favorite, setFavorite] = React.useState(false);
  const [idWhistListProduct, setIdWhistListProduct] = React.useState(null);
  const {id} = useParams();

  useEffect(() => {
    if (item && item.product) {
      setFavorite(item.product.favorite);
      setIdWhistListProduct(item.product.wishListIdProduct);
    }
  }, [item]);

  console.log('Item:', item);
  return (
    !loading &&
    item && (
      <Stack sx={{maxWidth: '498px'}} spacing={4}>
        <Stack direction={'row'} alignItems={'center'} spacing={2}>
          <Typography variant={'h2'} sx={{color: mode.settings.textColor3}}>
            {item.product.name}
          </Typography>

          {favorite ? (
            <StarIcon
              sx={{color: '#EFBA00'}}
              fontSize={'large'}
              onClick={() => {
                const done = removeFromFavorite(id, idWhistListProduct);
                if (done) {
                  setFavorite(false);
                }
              }}
            />
          ) : (
            <StarBorderIcon
              sx={{color: '#EFBA00'}}
              fontSize={'large'}
              onClick={async () => {
                const resId = await addToFavorite(id, item.product.wishlistId);
                if (resId) {
                  setFavorite(true);
                  setIdWhistListProduct(resId);
                }
              }}
            />
          )}
        </Stack>
        <Divider />
        {(item.product.payment_type != 4 && item.product.price &&
            parseFloat(item.product.price).toFixed(2).replace('.', ',') != '0,00'
        ) && (
          <Stack spacing={1}>
            <Typography
              sx={{color: mode.settings.textColor3}}
              variant={'subtitle10'}>
              Prix du service
            </Typography>
            <Box
              sx={{
                borderRadius: '5px',
                borderWidth: '2px',
                borderColor: '#F0F2F8',
                borderStyle: 'solid',
                padding: '5px',
                width: 'fit-content',
              }}>
              <Typography
                sx={{color: mode.settings.textColor3}}
                variant={'subtitle12'}>
                {parseFloat(item.product.price).toFixed(2).replace('.', ',')} €
              </Typography>
            </Box>
          </Stack>
        )}
        <DynamicForm form={item.form} product={item.product} />
      </Stack>
    )
  );
};

export default withServiceListContext(ItemDetailInformation);
